const nf0 = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export const inteiro = (n: number | null | undefined) => (n === null || n === undefined ? '—' : nf0.format(n));
export const decimal = (n: number | null | undefined) => (n === null || n === undefined ? '—' : nf1.format(n));
export const pct = (n: number | null | undefined) => (n === null || n === undefined ? '—' : `${nf1.format(n)}%`);
export const sinal = (n: number) => `${n > 0 ? '+' : n < 0 ? '−' : ''}${nf1.format(Math.abs(n))}`;

const fusoFortaleza = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Fortaleza' });

/** YYYY-MM-DD de hoje, ou de N dias atrás, no fuso do negócio (a Paraíba usa America/Fortaleza). */
export const diaIso = (diasAtras = 0, agora = Date.now()) => fusoFortaleza.format(new Date(agora - diasAtras * 86_400_000));

/** "28/10" ou "28/10/2026" a partir de YYYY-MM-DD, sem passar por Date (evita deslocar o dia por fuso). */
export function dataCurta(iso: string | null | undefined, comAno = false): string {
  if (!iso) return '—';
  const [a, m, d] = iso.slice(0, 10).split('-');
  return comAno ? `${d}/${m}/${a}` : `${d}/${m}`;
}

/** "agora", "há 5 min", "há 3 h", "ontem", "há 4 dias", ou a data. */
export function tempoRelativo(iso: string, agora = Date.now()): string {
  const seg = Math.max(0, Math.round((agora - new Date(iso).getTime()) / 1000));
  if (seg < 60) return 'agora';
  const min = Math.floor(seg / 60);
  if (min < 60) return `há ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `há ${h} h`;
  const d = Math.floor(h / 24);
  if (d === 1) return 'ontem';
  if (d < 30) return `há ${d} dias`;
  return dataCurta(fusoFortaleza.format(new Date(iso)), true);
}

export const ROTULO_STATUS: Record<string, string> = {
  PLANEJADA: 'Planejada',
  EM_ANDAMENTO: 'Em andamento',
  CONCLUIDA: 'Concluída',
  SUSPENSA: 'Suspensa',
  CANCELADA: 'Cancelada',
};

export const ROTULO_PERFIL: Record<string, string> = {
  SUPERADMIN: 'Superadmin',
  ADMIN_GESTOR: 'Gestor',
  SECRETARIO: 'Secretário',
  OPERADOR: 'Operador',
  PESQUISADOR: 'Pesquisador',
  LEITOR: 'Leitor',
};

export const plural = (n: number, um: string, varios: string) => `${inteiro(n)} ${n === 1 ? um : varios}`;

/**
 * Formata o valor de um indicador pela UNIDADE dele: "73,5%", "7,0 anos", "R$ 2.789", "R$ 28,4 bi", "5,6".
 * Valores em "R$ mil" (PIB) viram bilhões/milhões para caber na tela.
 */
export function formatarIndicador(v: number | null | undefined, unidade: string, casas: number): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return '—';
  const n = (x: number, c: number) => new Intl.NumberFormat('pt-BR', { minimumFractionDigits: c, maximumFractionDigits: c }).format(x);
  if (unidade === '%') return `${n(v, casas)}%`;
  if (unidade === 'anos') return `${n(v, casas)} anos`;
  if (unidade === 'R$ mil') {
    const reais = v * 1000;
    if (reais >= 1e9) return `R$ ${n(reais / 1e9, 1)} bi`;
    if (reais >= 1e6) return `R$ ${n(reais / 1e6, 1)} mi`;
    return `R$ ${n(reais, 0)}`;
  }
  if (unidade.startsWith('R$')) return `R$ ${n(v, 0)}`;
  return n(v, casas); // pessoas, hab/km², por 10 mil hab. ...
}

/** "93,9% na posição 1 de 223". */
export const posicaoTexto = (posicao: number | null, de: number) => (posicao === null ? '' : `${posicao}º de ${de}`);
